import { Injectable, signal, WritableSignal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AppService {
  public readonly appName = 'echo.';
  /**
   * Set the application header title from every component inside the app
   */
  headerTitle: WritableSignal<string> = signal(this.appName);
}
